import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class AcessoGovBrBronzeRouterService
{
    constructor(private router: Router) {}
}
